import { TranscriptCategories } from '../model/transcript-categories.model';

export function filterSummaryBySubBehaviour(
    subBehaviourId: number | null,
    categories: TranscriptCategories[],
): TranscriptCategories[] {
    if (subBehaviourId == null) {
        return [...categories];
    }

    return categories.map((c) => {
        const nextC = { ...c };

        nextC.subCategories = c.subCategories.map((sub) => {
            const nextSub = { ...sub };

            nextSub.transcripts = sub.transcripts.filter((t) => {
                return (
                    t.primaryFocus?.subBehaviourId === subBehaviourId ||
                    t.behaviours.some(
                        (p) => p.subBehaviourId === subBehaviourId,
                    )
                );
            });

            return nextSub;
        });

        return nextC;
    });
}
